<template>
  <div id="Emergency_apply">
    <div class="font">
      <span class="introSubTitle"><b>空天地一体遥感应急指挥系统</b></span>
      <p class="textStyle">
        研发了空天地一体化无人区应急指挥系统，首次在无人区将卫星、飞艇、无人机、地面终端四种手段联合进行一体化观测，填补了空天地遥感协同监测用于突发事件应急的空白，解决了“最后1公里”的问题，大幅提升了一线人员在无人山区开展应急工作处置能力。
      </p>
    </div>
    <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/Emergency.jpg" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
#Emergency_apply {
  margin-top: 20px;
}
</style>
